import { upperFirst } from 'lodash';
import { FIELD_TYPE } from 'schemas/types';

const textFieldIds = [
  'endpoint.os',
  'endpoint.id',
  'endpoint.type',
  'endpoint.macAddress',
  'event.relatedToThreat',
  'event.classification',
  'event.externalID',
  'event.externalThreatValue',
  'event.status',
  'event.certainty',
  'event.outcome.result',
  'event.outcome.reason',
  'event.mitreTactic',
  'event.mitreTechnique.name',
  'event.mitreTechnique.id',
  'src.process.cmdline',
  'src.process.image.path',
  'src.process.pid',
  'src.process.displayName',
  'src.process.name',
  'src.process.image.binaryIsExecutable',
  'src.process.integrityLevel',
  'src.process.signedStatus',
  'src.process.publisher',
  'src.process.verifiedStatus',
  'src.process.reasonSignatureInvalid',
  'src.process.image.sha1',
  'src.process.image.md5',
  'src.process.image.sha256',
  'src.process.subsystem',
  'src.process.sessionId',
  'src.process.isNative64Bit',
  'src.process.isRedirectCmdProcessor',
  'src.process.activeContentType',
  'src.process.activeContent.id',
  'src.process.activeContent.path',
  'src.process.activeContent.hash',
  'src.process.activeContent.signedStatus',
  'cmdScript.content',
  'cmdScript.isComplete',
  'cmdScript.sha256',
  'cmdScript.originalSize',
  'cmdScript.applicationName',
  'src.process.parent.cmdline',
  'src.process.parent.image.path',
  'src.process.parent.displayName',
  'src.process.parent.name',
  'src.process.parent.integrityLevel',
  'src.process.parent.signedStatus',
  'src.process.parent.publisher',
  'src.process.parent.image.sha1',
  'src.process.parent.image.md5',
  'src.process.parent.image.sha256',
  'src.process.parent.sessionId',
  'src.process.parent.isNative64Bit',
  'src.process.parent.isRedirectCmdProcessor',
  'src.process.parent.pid',
  'tgt.process.relation',
  'tgt.process.cmdline',
  'tgt.process.image.path',
  'tgt.process.pid',
  'tgt.process.displayName',
  'tgt.process.name',
  'tgt.process.image.binaryIsExecutable',
  'tgt.process.integrityLevel',
  'tgt.process.signedStatus',
  'tgt.process.publisher',
  'tgt.process.verifiedStatus',
  'tgt.process.reasonSignatureInvalid',
  'tgt.process.image.sha1',
  'tgt.process.image.md5',
  'tgt.process.image.sha256',
  'tgt.process.subsystem',
  'tgt.process.sessionId',
  'tgt.process.isNative64Bit',
  'tgt.process.isRedirectCmdProcessor',
  'tgt.process.activeContentType',
  'tgt.process.activeContent.id',
  'tgt.process.activeContent.path',
  'tgt.process.activeContent.hash',
  'tgt.process.activeContent.signedStatus',
  'tgt.process.accessRights',
  'src.port.number',
  'dst.port.number',
  'event.network.direction',
  'event.network.connectionStatus',
  'event.network.protocolName',
  'event.dns.response',
  'event.url.action',
  'tgt.file.oldPath',
  'tgt.file.type',
  'tgt.file.size',
  'tgt.file.extension',
  'tgt.file.id',
  'tgt.file.description',
  'tgt.file.internalName',
  'tgt.file.location',
  'tgt.file.md5',
  'tgt.file.sha1',
  'tgt.file.sha256',
  'tgt.file.isSigned',
  'tgt.file.isExecutable',
  'tgt.file.oldSha1',
  'tgt.file.oldMd5',
  'tgt.file.oldSha256',
  'registry.keyUid',
  'registry.valueType',
  'registry.value',
  'registry.valueFullSize',
  'registry.valueIsComplete',
  'registry.oldValueType',
  'registry.oldValue',
  'registry.oldValueFullSize',
  'registry.oldValueIsComplete',
  'task.path',
  'module.sha1',
  'module.md5',
  'event.login.baseType',
  'event.login.loginIsSuccessful',
  'event.login.accountName',
  'event.login.type',
  'event.login.isAdministratorEquivalent',
  'event.login.failureReason',
  'event.login.accountSid',
  'event.login.accountDomain',
  'event.login.sessionId',
  'k8sCluster.name',
  'k8sCluster.nodeName',
  'k8sCluster.namespace',
  'k8sCluster.namespaceLabels',
  'k8sCluster.controllerType',
  'k8sCluster.controllerName',
  'k8sCluster.controllerLabels',
  'k8sCluster.podName',
  'k8sCluster.podLabels',
  'k8sCluster.containerName',
  'k8sCluster.containerId',
  'k8sCluster.containerLabels',
  'k8sCluster.containerImage',
  'src.process.parent.reasonSignatureInvalid',
  'src.process.parent.activeContentType',
  'src.process.parent.activeContent.id',
  'src.process.parent.activeContent.path',
  'src.process.parent.activeContent.hash',
  'src.process.parent.activeContent.signedStatus',
  'actor.id',
  'actor.alternateID',
  'actor.displayName',
  'actor.privilege',
  'alert.ruleID',
  'alert.name',
  'alert.description',
  'alert.eventIDs',
];

const timestampFieldIds = [
  'event.startTime',
  'event.endTime',
  'src.process.startTime',
  'src.process.parent.startTime',
  'tgt.file.creationTime',
  'tgt.file.modificationTime',
  'tgt.process.startTime',
];

const convertToField = (fieldIds: ReadonlyArray<string>, type: FIELD_TYPE) =>
  fieldIds.reduce(
    (acc, fieldId) => ({
      ...acc,
      [fieldId]: {
        type,
        label: fieldId.split('.').map(upperFirst).join(' '),
      },
    }),
    {},
  );

export const textFields = convertToField(textFieldIds, FIELD_TYPE.TEXT);
export const timestampFields = convertToField(timestampFieldIds, FIELD_TYPE.TIMESTAMP);
